import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { isAdminWallet } from '../Admin/adminWallets';
import { useConnectWallet } from "@web3-onboard/react";

const ModalMenu = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [{ wallet }] = useConnectWallet();

  useEffect(() => {
    if (wallet) {
      setIsAdmin(isAdminWallet(wallet?.accounts[0]?.address));
    } else {
      setIsAdmin(false);
    }
  }, [wallet]);

  return (
      <div id="menu" className="modal fade p-0">
        <div className="modal-dialog dialog-animated">
          <div className="modal-content h-100">
            <div className="modal-header" data-dismiss="modal">
              Menu <i className="far fa-times-circle icon-close" />
            </div>
            <div className="menu modal-body">
              <div className="row w-100">
                <ul className="navbar-nav items mx-auto">
                  <li className="nav-item">
                    <a href="/" className="nav-link">
                      Staking Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="https://timmy.finance" className="nav-link">
                      Timmy Finance Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a href="https://timmy.finance/coinflip" className="nav-link">
                      Coinflip
                    </a>
                  </li>
                  {isAdmin && (
                      <li className="nav-item">
                    <span className="nav-link">
                      <a href="/admin">Admin</a>
                    </span>
                      </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ModalMenu;
